<div class="component-container">
  <form
    [formGroup]="form"
  >
    <div class="row flex flex-row space-x-[2.5rem] w-full">
      <app-text-input
        class="input w-full md:w-1/2"
        [parentFormGroup]="form"
        controlName="emailId"
        placeholder="user@mail.com"
        label="Email"
        [error]="errorMessages['emailId']"
        [maxLength]="validation.email.length.max"
        type="small"
      ></app-text-input>
      <app-search-on-select
        class="input w-full md:w-1/2"
        [parentFormGroup]="form"
        [options]="usernameFilter.list"
        [loading]="usernameFilter.loading"
        [error]="errorMessages['userId']"
        (onNextPage)="usernamesOnNextPage()"
        [hasNext]="usernameFilter.hasNext"
        [enableClearSelection]="enableUsernameClearSelection"
        controlName="userId"
        filterControlName="searchUsername"
        label="Username"
        placeholder="Select a user"
        type="small"
      />
    </div>
    <div class="row flex flex-row space-x-[2.5rem] w-full">
      <app-check-box-input
        [parentFormGroup]="form"
        controlName="isLar"
        [error]="errorMessages['isLar']"
        label="Legally Authorized Representative"
        type="small"
      />
    </div>
  </form>
</div>
